import styled from 'styled-components'

/**
 * Card list for the accepted creatives, replacing the table on the offsite
 * briefing flow only. Mirrors the prototype's `dv360-creatives` block
 * (ads-design-prototypes, feat/offsite — PR #44): a table row cannot hold
 * four fields per creative without cramping them, and the destination URL
 * column alone was already flagged as too narrow to read (2026-09-15 demo,
 * SPEC 004 items 4.3 and 7.1).
 */
export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-3);
  margin-top: var(--sl-space-5);
`

export const Header = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--sl-space-3);
`

export const Title = styled.strong`
  margin: 0;
  font: var(--sl-text-emphasis-font);
  color: var(--sl-fg-base);
`

export const Count = styled.span`
  margin: 0;
  font: var(--sl-text-caption-1-font);
  color: var(--sl-fg-base-soft);
`

export const Card = styled.article`
  border: var(--sl-border-base);
  border-radius: var(--sl-radius-2);
  background: var(--sl-bg-base);
  padding: var(--sl-space-4);
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-4);
`

export const Head = styled.div`
  display: flex;
  align-items: center;
  gap: var(--sl-space-3);
`

// The prototype shows a generic icon tile here; we already have the real
// creative, so the thumbnail takes that slot.
export const Thumb = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 2.5rem;
  height: 2.5rem;
  overflow: hidden;
  border-radius: var(--sl-radius-2);
  background: var(--sl-bg-accent);
  color: var(--sl-fg-accent);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const Meta = styled.span`
  min-width: 0;
  flex: 1;
`

export const Name = styled.span`
  display: block;
  font: var(--sl-text-emphasis-font);
  color: var(--sl-fg-base);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

// Takes the prototype's "type" slot, but carries the placement/image sizes
// instead — the information the table's size column used to show, which
// would otherwise be lost in the move to cards.
export const Sizes = styled.span`
  display: block;
  font: var(--sl-text-caption-1-font);
  color: var(--sl-fg-base-soft);
`

export const Fields = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--sl-space-4);
`

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-1);

  label {
    font: var(--sl-text-caption-1-font);
    color: var(--sl-fg-base);
    margin-bottom: 0;
  }

  .required {
    color: var(--sl-fg-critical);
  }
`
